
import { useEffect } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Provider, useDispatch, useSelector } from 'react-redux';
import AuthLayout from 'src/layout/AuthLayout';
import AppLayout from 'src/layout/AppLayout';
import AppLoader from 'src/layout/AppLoader';
import AppRouter from './router';
import OnBoardingLayout from './layout/OnBoardingLayout';
import 'src/assets/css/fonts.css';
import 'src/assets/css/app.css';
import Toast from './components/shared/Toast';
import ErrorBoundary from 'src/components/shared/ErrorBoundary';
import GlobalLoader from 'src/components/shared/GlobalLoader';

import theme from 'src/config/theme';
import { authPages } from 'src/config';
import { restoreSession } from 'src/modules/auth/store/authActions';
import { useLocation } from 'react-router-dom';
import toast from './utils/toast';
import { db } from './firebase';
import { doc, onSnapshot } from 'firebase/firestore';

const startTime = Date.now();

function App({ ...props }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const userId = user?.id;

  useEffect(() => {
    dispatch(restoreSession());
  }, []);

  useEffect(() => {
    if (userId) {
      console.log("Real-time signals enabled for user:", userId);
      const unsub = onSnapshot(doc(db, "user_updates", userId), (doc) => {
        const data = doc.data();
        if (data && data.timestamp > startTime) {
          console.log("Real-time signal received:", data);
          toast.info(`Real-time update: ${data.type || 'data'} refreshed.`);
          
          // You can dispatch specific refresh actions here if needed
          // For now, it provides visual feedback
        }
      });
      return () => unsub();
    }
  }, [userId]);

  const loading = useSelector((state) => state.app.appLoading);
  const pathname = location.pathname;

  if (loading) return <AppLoader />;


  let Layout;
  if (pathname.startsWith('/auth')) {
    Layout = AuthLayout;
  } else if (pathname.startsWith('/public')) {
    Layout = OnBoardingLayout;
  } else {
    Layout = AppLayout;
  }

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Toast>
          <GlobalLoader />
          <Layout>
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </Layout>
        </Toast>
      </LocalizationProvider>
    </ThemeProvider>
  );
}


export default App;
